jQuery.feature_import("js-bugreportRoot",
  () => import("./BugReportMain.js"),
  mod => mod.feature_js_bugreportRoot
);